export default __webpack_public_path__ + "static/media/no-settings.febddc9b.svg";